import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Icon } from "../../components/Component";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { useForm } from "react-hook-form";
import { getImmunityResultById, getImmunityResults } from "../../api/testResult";
import { Badge } from "reactstrap";
import AnswerModal from "../../MyComp/UI/modals/AnswerModal";
import useLogout from "../../hooks/useLogout";
import { toast } from "react-toastify";

const ImmunityResult = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(false);
  };
  const logout =useLogout()
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      server_search: null,
      selectedRow: [],
      answer: [],
    },
  });
  const [columns, setColumns] = useState([
    {
      name: "Name",
      selector: (row) => row?.fullName,
      cell: (row) => <span className="text-capitalize">{row?.fullName}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      cell: (row) => <span className=" ">{row?.email}</span>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Mobile",
      selector: (row) => row?.mobile,
      sortable: true,
      wrap: true,
    },

    {
      name: "Result",
      selector: (row) => row?.result,
      cell: (row) => (
        <div
          style={{ cursor: "pointer" }}
          //  onClick={() => handleToggleStatus(row)}
        >
          <Badge className="text-capitalize" color={`${"outline-primary"}`}>
            {row.result}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Date",
      selector: (row) => row?.date,
      sortable: true,
    },

    {
      name: "Action",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleView(row)}>
            {" "}
            <Icon name="eye" />
          </Button>
        </div>
      ),
    },
  ]);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
  };
  const handleView = (row) => {
    setValue("selectedRow", row);
    const body={
      id:row?.id
    }
    getImmunityResultById(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setIsOpen(true);
          setValue("answer", res.data.data);
        } else if (status === false) {
        } else if (status === "expired") {
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("catch error", err);
      });
  };
  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),

      page: currentPage,
      limit: perPage,
    };
    getImmunityResults(body)
      .then((res) => {
        const status = res.data.status;
        if (status) {
          setIsLoading(false);
          setData(res.data.data.results);
        } else if (!status) {
          setIsLoading(false);
          setData([]);
        } else if (status === "expired") {
          setIsLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("catch error", err);
      });
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      serverSideSearch();
    }
  }, [watch("server_search")]);
  return (
    <>
      <Head title={"Immunity Result"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Immunity Results"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <ApiPaginationDataTable
            columns={columns}
            data={data}
            title={"Immunity Results"}
            isLoading={isLoading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            serverSearch
            serverSideSearch={serverSideSearch}
            paginationServer
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
        </Block>
      </Content>
      <AnswerModal
        isOpen={isOpen}
        data={watch("selectedRow")}
        answer={watch("answer")}
        toggle={toggle}
        title={"Immunity Test Result"}
      />
    </>
  );
};

export default ImmunityResult;
